<script lang="ts">
  import '../../../../app.postcss'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
</script>

<div class="mx-auto max-w-screen-xl-desktop">
  <section
    class="relative mt-16 flex h-[450px] items-center justify-between overflow-hidden lg-mobile:h-[500px] xl-mobile:h-[550px] sm:h-[650px] xl:mt-0 lg-desktop:h-[1000px]"
  >
    <div class="left-icon">
      <ButaneImage src="9.png" layout="fullWidth" alt="Company Hero Left Icon" class="object-contain" />
    </div>

    <h1
      class="mx-auto w-[60%] self-center text-center font-cirka text-[12vw] leading-[85%] md:w-[50%] md:text-[10vw] xl:w-[540px] xl:text-[110px]"
    >
      Committed to Openness
    </h1>

    <div class="right-icon">
      <ButaneImage src="6.png" layout="fullWidth" alt="Company Hero Right Icon" />
    </div>
  </section>
</div>

<style lang="postcss">
  .left-icon {
    left: -245px;
    top: -300px;
    transform: scale(1.1);
    width: 570px;
    position: absolute;
  }

  .right-icon {
    bottom: -250px;
    right: -210px;
    width: 500px;
    position: absolute;
  }

  @media (min-width: 425px) {
    .left-icon {
      width: 620px;
      left: -270px;
      top: -300px;
    }

    .right-icon {
      width: 550px;
      right: -230px;
      bottom: -260px;
    }
  }

  @media (min-width: 640px) {
    .left-icon {
      width: 750px;
      left: -325px;
      top: -350px;
    }

    .right-icon {
      width: 650px;
      right: -250px;
      bottom: -300px;
    }
  }

  @media (min-width: 1440px) {
    .left-icon {
      left: -215px;
      top: -30px;
      width: 743px;
    }

    .right-icon {
      bottom: 20px;
      right: -225px;
      width: 705px;
      transform: scale(1.1);
    }
  }
</style>
